import FuelApi from "../api/fuelApi";

export const GET_FUEL_DATA_REQUESTED = "fuel/GET_FUEL_DATA_REQUESTED";
export const GET_FUEL_DATA = "fuel/GET_FUEL_DATA";
export const DOWNLOAD_FUEL_XLS = "fuel/DOWNLOAD_FUEL_XLS";
export const GET_FUEL_DATA_REQUEST_ERROR = "fuel/GET_FUEL_DATA_REQUEST_ERROR";
export const CHANGE_FUEL_CURRENCY = "fuel/CHANGE_FUEL_CURRENCY";
export const CHANGE_FUEL_COST = "fuel/CHANGE_FUEL_COST";

const initialState = {
  data: {
    UnidadVelocidad: "Km",
    UnidadVolumen: "Lt",
    FechaInicial: null,
    FechaFinal: null,
    FechaPrimeraUbicacion: null,
    FechaUltimaUbicaion: null,
    Unidades: [],
    ReportesIndividuales: [],
    Eventos: [],
    Ubicaciones: [],
    ResumenComportamiento: null,
    CombustibleInicial: [],
    CombustibleFinal: [],
    CargasCombustible: [],
    DescargasCombustible: [],
    RalentiCombustible: [],
    CombustibleConsumido: [],
    VolumenesMaximos: []
  },
  cost: 0,
  currency: "MXP",
  isLoading: false,
  hasData: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FUEL_DATA_REQUESTED:
      return {
        ...state,
        isLoading: true
      };

    case GET_FUEL_DATA:
      return {
        ...state,
        isLoading: false,
        hasData: true,
        data: action.data
      };

    case GET_FUEL_DATA_REQUEST_ERROR:
      return {
        ...state,
        isLoading: false
      };

    case CHANGE_FUEL_COST:
      return {
        ...state,
        cost: action.cost
      };

    case CHANGE_FUEL_CURRENCY:
      return {
        ...state,
        currency: action.currency
      };

    case DOWNLOAD_FUEL_XLS:
      //"https://apps.zeekgps.com/alpha/GenerarReporte.aspx?sTipoReporte=puntos"
      window.open(
        "https://apps.zeekgps.com/alpha/GenerarReporte.aspx?sTipoReporte=temperatura&fInicial=1517126400000&fFinal=1517128974838&aUnidades=205170098st&zona=-8",
        "_blank"
      );
      return {
        ...state
      };

    default:
      return state;
  }
};

export const getFuelData = config => {
  return dispatch => {
    dispatch({
      type: GET_FUEL_DATA_REQUESTED
    });

    if (process.env.NODE_ENV === "development") {
      return FuelApi.getFuelDataFake(config)
        .then(data => {
          dispatch({
            type: GET_FUEL_DATA,
            data
          });
        })
        .catch(error => {
          dispatch({
            type: GET_FUEL_DATA_REQUEST_ERROR
          });
          throw error;
        });
    } else {
      return FuelApi.getFuelData(config)
        .then(data => {
          dispatch({
            type: GET_FUEL_DATA,
            data
          });
        })
        .catch(error => {
          dispatch({
            type: GET_FUEL_DATA_REQUEST_ERROR
          });
          throw error;
        });
    }
  };
};

export const downloadFuelXls = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_FUEL_XLS
    });
  };
};

export const changeFuelCurrency = currency => {
  return dispatch => {
    dispatch({
      type: CHANGE_FUEL_CURRENCY,
      currency
    });
  };
};

export const changeFuelCost = cost => {
  return dispatch => {
    dispatch({
      type: CHANGE_FUEL_COST,
      cost
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/fuel.js